import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";

enum Action {
    UpdateFilters,
}

interface ISelectListItem {
    text: string,
    value: string,
}

//interface IProps {
//    groupLevels: Array<ISelectListItem>;
//    groupTypes: Array<ISelectListItem>;
//    trainers: Array<ISelectListItem>;
//    locations: Array<ISelectListItem>;
//    showGroupLevelsWith: Array<string>;
//    groupType: string;
//    groupLevel: string;
//    trainer: string;
//    location: string;
//}

interface IFilters {
    groupLevels: Array<ISelectListItem>;
    groupTypes: Array<ISelectListItem>;
    trainers: Array<ISelectListItem>;
    locations: Array<ISelectListItem>;
}

@Component
export default class TimetableFilters extends Vue {
    @Prop() groupLevels: Array<ISelectListItem>;
    @Prop() groupTypes: Array<ISelectListItem>;
    @Prop() trainers: Array<ISelectListItem>;
    @Prop() locations: Array<ISelectListItem>;
    @Prop() showGroupLevelsWith: Array<string>;
    @Prop() groupType: string;
    @Prop() groupLevel: string;
    @Prop() trainer: string;
    @Prop() location: string;

    mounted() {

    }

    get shouldShowGroupLevels(): boolean {
        if (!this.groupType) {
            return false;
        }
        var index = this.showGroupLevelsWith.indexOf(this.groupType.toLowerCase());
        return index > -1;
    }

    updateFilters() {
        let component = this;

        var data = {
            groupLevel: component.groupLevel,
            groupTypeId: component.groupType,
            trainerId: component.trainer,
            locationId: component.location
        }

        ajax(Uri.getUri(Action[Action.UpdateFilters]), { dataType: "json", method: "post", data: data })
            .done((res: IFilters) => {

                if (!res) {
                    return;
                }

                if (!component.location) {
                    component.$emit('update:locations', res.locations);
                    //component.locations = res.locations;
                }

                if (!component.groupLevel) {
                    component.$emit('update:groupLevels', res.groupLevels);

                    //component.groupLevels = res.groupLevels;
                }

                if (!component.groupType) {
                    component.$emit('update:groupTypes', res.groupTypes);

                    //component.groupTypes = res.groupTypes;
                }

                if (!component.trainer) {
                    component.$emit('update:trainers', res.trainers);

                    //component.trainers = res.trainers;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/TimetableFilters/TimetableFilters.ts